const TYPE_COMPTA = {
	HT: 1,
	TTC: 2,
} as const;

export default TYPE_COMPTA;
